import { IoRefreshOutline } from 'react-icons/io5'
import { vccBtn } from '@shared/ui/vccButtons'

export interface ResetButtonProps {
  onClick: () => void
  disabled?: boolean
  type?: 'button' | 'submit'
  className?: string
  label?: string
  showIcon?: boolean
}

export default function ResetButton({
  onClick,
  disabled,
  type = 'button',
  className = '',
  label = 'Reset',
  showIcon = true,
}: ResetButtonProps) {
  return (
    <button
      type={type}
      className={`${vccBtn('reset')} ${className}`.trim()}
      onClick={onClick}
      disabled={disabled}
    >
      {showIcon && <IoRefreshOutline aria-hidden className="vcc-btn__icon" />}
      {label}
    </button>
  )
}